import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/sections/About";
import Education from "./components/sections/Education";
import Experience from "./components/sections/Experience";
import Skills from "./components/sections/Skills";
import Projects from "./components/sections/Projects";
import AgentModal from "./components/AgentModal";
import Footer from "./components/Footer";
import { useTheme } from "./utils/theme";
import { enableSmoothScroll } from "./utils/smoothScroll";
import AgentSection from "./components/sections/AgentSection";

export default function App() {
  useEffect(() => enableSmoothScroll(), []);
  const { isLight, setIsLight, classes } = useTheme();

  const [openAgent, setOpenAgent] = useState(false);


  return (
    <div
      className={`min-h-screen ${classes.pageBg} selection:bg-cyan-300 selection:text-slate-900`}
    >
      {/* Fonts */}
      <link
        rel="preconnect"
        href="https://fonts.googleapis.com"
      />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin=""
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;600;700&display=swap"
        rel="stylesheet"
      />

      <Header isLight={isLight} setIsLight={setIsLight} />
      <Hero gradientBg={classes.gradientBg} />
      <About sectionTint={classes.sectionTint} />
      <Experience sectionTint={classes.sectionTint} />
      <Projects cardBg={classes.cardBg} />
      <Skills sectionTint2={classes.sectionTint2} />
      <Education sectionTint2={classes.sectionTint2} />
      <AgentSection sectionTint={classes.sectionTint} />

      <Footer />

      {/* Drawer Modal */}
      <AgentModal open={openAgent} onClose={() => setOpenAgent(false)} />
    </div>
  );
}
